module.exports = __webpack_public_path__ + "img/item_Portrait_03.f6416a6f.jpeg";